import { storage } from '@/lib/storage';

/**
 * La preferenza «Valuta le mie mosse» sul DISPOSITIVO (spec-20b §2): non cambia il default (spento: il valore a schermo e'
 * quello che il server dice in `coach:history`), serve a ripetere la tua scelta alla partita dopo. Nessuna preferenza per
 * utente: e' una SCELTA di Luca, qui non c'e'.
 *
 * ⚠️ La chiave sta QUI e non in `StorageKey` (`lib/storage.ts`): `storage.get/set` prendono una stringa qualunque, e cosi' in
 * produzione, dove nessun modulo del coach e' raggiungibile, la stringa non e' in nessun file (tma-orcr, 31/10 21:20Z). Solo
 * `'1'` accende; un valore che non conosciamo, o un `localStorage` che lancia, valgono «spento».
 */
export const CHIAVE_COACH = 'qlash.backgammon.coach';

export function leggiCoach(): boolean {
  return storage.get(CHIAVE_COACH) === '1';
}

export function scriviCoach(acceso: boolean): void {
  storage.set(CHIAVE_COACH, acceso ? '1' : '0');
}
